import FallbackSvg from '@/assets/logos/creditCards/FallbackCard.svg?url';
import VisaSvg from '@/assets/logos/creditCards/Visa.svg?url';
import AmexSvg from '@/assets/logos/creditCards/Amex.svg?url';
import DiscoverSvg from '@/assets/logos/creditCards/Discover.svg?url';
import MastercardSvg from '@/assets/logos/creditCards/Mastercard.svg?url';

const BRAND_MAP: Record<string, string> = {
  Visa: VisaSvg,
  MasterCard: MastercardSvg,
  'American Express': AmexSvg,
  Discover: DiscoverSvg,
};

interface CreditCardBrandLogoProps {
  card_type: string | null;
}

export const CreditCardBrandLogo: React.FC<CreditCardBrandLogoProps> = ({ card_type }) => {
  const src = (card_type && BRAND_MAP[card_type]) ?? FallbackSvg;
  const alt = card_type ?? 'Credit card';

  return (
    <img
      src={src}
      alt={alt}
      height={25}
      width={36}
    />
  );
};
